import { useQuery } from "@tanstack/react-query";
import { getTiptapCloudDocument } from "src/services/backend";
import type { TiptapDocumentEditOperation } from "src/tiptap/lib/document-edit-preview";

export const useTiptapDocumentEditPreview = ({
  orgId,
  documentName,
  operations,
  enabled,
}: {
  orgId: string;
  documentName: string;
  operations: TiptapDocumentEditOperation[];
  enabled: boolean;
}) =>
  useQuery({
    queryKey: ["tiptap-document-edit-preview", orgId, documentName, operations],
    queryFn: async () => {
      const {
        previewDocumentEdit,
        getDocumentEditComparison,
        getDocumentEditAnnotationEffects,
      } = await import("src/tiptap/lib/document-edit-preview");
      const response = await getTiptapCloudDocument({
        orgId,
        documentName,
      });
      const documents = previewDocumentEdit(response.data.content, operations);
      return {
        source: response.data.content,
        comparison: getDocumentEditComparison(documents),
        annotationEffects: getDocumentEditAnnotationEffects(documents),
      };
    },
    enabled: enabled && !!orgId && !!documentName && operations.length > 0,
    retry: false,
    gcTime: 0,
    throwOnError: false,
  });
